import { StyledIcons } from './styles/NavPage.styled'
import { NavLink } from './styles/NavPage.styled'

import { Lpg, Market, Plants, Trucking, Refinery, Producers, Shipping, BoatCruise, Pricing, Hseq } from '../../../assets/svg/Navicons/NavIcons'

 
export const NavIcons = ({onHover1, onHover2, onHover3, onHover4, onHover5, onHover6, onHover7, onHover8, onHover9, onHover10, onLeave}) => (
    <StyledIcons onMouseOut={onLeave}>
        <NavLink onMouseOver={onHover1}  to='/landing'>
            <Lpg />
        </NavLink> 
        <NavLink onMouseOver={onHover2} to='/landing'>
           <Market />
          </NavLink> 
        <NavLink  onMouseOver={onHover3} to='/landing'>
            <Plants />
        </NavLink> 
        <NavLink  onMouseOver={onHover4} to='/landing'>
            <Trucking />
        </NavLink> 
        <NavLink  onMouseOver={onHover5} to='/landing'>
            <Refinery />
        </NavLink> 
        <NavLink  onMouseOver={onHover6} to='/landing'>
            <Producers />
        </NavLink> 
        <NavLink  onMouseOver={onHover7} to='/landing'>
            <Shipping />
        </NavLink> 
        <NavLink  onMouseOver={onHover8} to='/landing'>
            <BoatCruise />
        </NavLink> 
        <NavLink  onMouseOver={onHover9} to='/landing'>
            <Pricing />
        </NavLink> 
        <NavLink  onMouseOver={onHover10} to='/landing'>
            <Hseq />
        </NavLink> 
       
    </StyledIcons>
)